@if ((linkedEntitiesGroups?.length && overallEntitiesCount) || displayOnDemand) {
  <div>
    <span
      class="flex gap-x-2 items-center font-main"
      [placement]="'top bottom left'"
      [ngbTooltip]="allowTooltip && tooltipTemplate"
      [keepOnHover]="true"
      tooltipClass="default-tooltip linked-entities-tooltip {{ tooltipClasses || '' }}"
    >
      @if (labelIcon) {
        <svg-icon [ngClass]="labelIconClasses" [src]="labelIcon"></svg-icon>
      }
      {{ textInLabel | translate: { overallEntitiesCount } }}
    </span>
  </div>
}

<ng-template #noEntitiesButton>{{ textInLabelNoLinks | translate }}</ng-template>

<ng-template #tooltipTemplate>
  <div class="flex flex-col content-start min-w-52 max-h-52 overflow-auto pl-1 pt-1 pb-1 pr-2">
    @if (overallEntitiesCount > 0) {
      <p class="font-semibold mb-4">
        {{ textInTooltip | translate: { overallEntitiesCount } }}
      </p>
    } @else {
      <p class="font-semibold mb-4">
        {{ textTooltipNoLinks | translate }}
      </p>
    }

    @for (linkedEntitiesGroup of linkedEntitiesGroups; track $index) {
      <div class="mb-4">
        <span class="font-semibold inline-block mb-2">{{ linkedEntitiesGroup.title }}:</span>
        <ul class="pl-3">
          @for (entity of linkedEntitiesGroup.entities; track entity) {
            <li class="mb-2">
              <div
                class="flex flex-row items-center justify-between"
                [ngClass]="{ 'underline cursor-pointer': !entity.disabled, 'pointer-events-none': entity.disabled }"
                (click)="linkClick.next(entity)"
              >
                <span class="max-w-36 inline-block overflow-hidden whitespace-nowrap overflow-ellipsis">
                  {{ entity.title }}
                </span>
                @if (!entity.disabled) {
                  <svg-icon src="newscreen" preserveAspectRatio="none" [stretch]="true"></svg-icon>
                }
              </div>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</ng-template>
